<div
  class="mobile-show-button mobile-visibility-{{ mobileVisibilityState }}"
  (click)="onLogoClick()"
  *ngIf="mobile"
>
  <div class="d-inline-block">
    <i class="new-sidebar__icon fe fal fa-fw fa-lg fe-triangle"></i>
  </div>
</div>

<nav
  class="navbar navbar-vertical navbar-expand-xs navbar-dark navbar-inverted"
  [class.d-none]="wls.getI('sidebar.hidden') || (hideSidebar | async)"
  [class.isWL]="wls.isWhiteLabel | async"
  [class.show]="mobileVisibilityState === 'visible'"
  [@mobileVisibilityState]="mobileVisibilityState"
  *ngIf="items$ | async as items"
>
  <div class="collapse navbar-collapse h-100">
    <div class="navbar-vertical-content h-100">
      <ul class="navbar-nav flex-column h-100">
        <ng-container *ngFor="let item of items; trackBy: trackByAlias">
          <app-sidebar-item
            *ngIf="!item.visible || (item.visible | async)"
            [item]="item"
            (toggle)="onToggle($event)"
            (clicked)="onClick()"
            class="{{ item.class }}"
          ></app-sidebar-item>
        </ng-container>
      </ul>
    </div>
  </div>
</nav>
